"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HDRSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16,13.52h-.78V17.9h.63c1.4,0,2.11-.74,2.11-2.21S17.34,13.52,16,13.52Z"/><path d="M22.83,13.52h-.44v1.82h.47a1.83,1.83,0,0,0,1-.23.8.8,0,0,0,.33-.71.74.74,0,0,0-.33-.68A2.08,2.08,0,0,0,22.83,13.52Z"/><path d="M29,6.09H3a1,1,0,0,0-1,1v18a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1v-18A1,1,0,0,0,29,6.09Zm-16.93,13H10.62V16.17H7.9v2.91H6.44V12.35H7.9V15h2.72V12.35h1.45Zm6.47-.89a4,4,0,0,1-2.79.89H13.81V12.35H16a3.68,3.68,0,0,1,2.62.87,3.16,3.16,0,0,1,.93,2.43A3.23,3.23,0,0,1,18.54,18.19Zm6.27.89L23.17,16.5h-.78v2.58H20.93V12.35h2a3.51,3.51,0,0,1,2.07.5,1.76,1.76,0,0,1,.67,1.52,1.77,1.77,0,0,1-.33,1.05,2.22,2.22,0,0,1-1,.73c1,1.51,1.71,2.49,2,2.93Z"/>';
var HDRSVG = function HDRSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HDRSVG = HDRSVG;
HDRSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HDRSVG);
exports.default = _default;